import React, {
	lazy,
	Suspense,
	useCallback,
	useState
} from 'react';
import PropTypes from 'prop-types';
import { Header } from 'semantic-ui-react';

const TemplateTypeLabel = ( {
	text,
	description
} ) => {
	const [ mouseOver, setMouseOver ] = useState( false );

	const iconComponent = text.split( ' ' ).join( '' );
	const Icon = lazy( () => import( `../SubmissionIcons/${ iconComponent }` ).catch( () => ( { default: null } ) ) );

	const handleMouseEnter = useCallback( () => {
		setMouseOver( true );
	}, [] );

	const handleMouseLeave = useCallback( () => {
		setMouseOver( false );
	}, [] );

	return (
		<div
			onMouseEnter={ handleMouseEnter }
			onMouseLeave={ handleMouseLeave }
			style={ {
				display: 'flex',
				alignItems: 'center',
				padding: '0.5rem',
				outline: mouseOver ? 'black auto 1px' : ''
			} }
		>
			<Suspense fallback={ null }>
				<div style={{
					border: '1px solid',
					borderRadius: '0.33333333rem',
					padding: '0.5rem'
				}}
				>
					<Icon
						width={ 48 }
						height={ 48 }
					/>
				</div>
			</Suspense>
			<div style={ { marginLeft: '1rem' } }>
				<Header style={ { marginBottom: 0 } }>{ text }</Header>
				<p>{ description || '' }</p>
			</div>
		</div>
	);
};

TemplateTypeLabel.propTypes = {
	text: PropTypes.string,
	description: PropTypes.string
};

export default TemplateTypeLabel;
